'use strict';

var _slicedToArray = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/slicedToArray");

var _createForOfIteratorHelper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _objectSpread = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/objectSpread2");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var debug = require('debug');

var log = Object.assign(debug('libp2p:identify'), {
  error: debug('libp2p:identify:err')
});

var errCode = require('err-code');

var lp = require('it-length-prefixed');

var _require = require('it-pipe'),
    pipe = _require.pipe;

var _require2 = require('streaming-iterables'),
    collect = _require2.collect,
    take = _require2.take,
    consume = _require2.consume;

var _require3 = require('uint8arrays/from-string'),
    uint8ArrayFromString = _require3.fromString;

var PeerId = require('peer-id');

var _require4 = require('multiaddr'),
    Multiaddr = _require4.Multiaddr; // @ts-ignore it-buffer does not have types


var _require5 = require('it-buffer'),
    toBuffer = _require5.toBuffer;

var Message = require('./message');

var Envelope = require('../record/envelope');

var PeerRecord = require('../record/peer-record');

var _require6 = require('./consts'),
    MULTICODEC_IDENTIFY = _require6.MULTICODEC_IDENTIFY,
    MULTICODEC_IDENTIFY_PUSH = _require6.MULTICODEC_IDENTIFY_PUSH,
    IDENTIFY_PROTOCOL_VERSION = _require6.IDENTIFY_PROTOCOL_VERSION,
    MULTICODEC_IDENTIFY_PROTOCOL_NAME = _require6.MULTICODEC_IDENTIFY_PROTOCOL_NAME,
    MULTICODEC_IDENTIFY_PUSH_PROTOCOL_NAME = _require6.MULTICODEC_IDENTIFY_PUSH_PROTOCOL_NAME,
    MULTICODEC_IDENTIFY_PROTOCOL_VERSION = _require6.MULTICODEC_IDENTIFY_PROTOCOL_VERSION,
    MULTICODEC_IDENTIFY_PUSH_PROTOCOL_VERSION = _require6.MULTICODEC_IDENTIFY_PUSH_PROTOCOL_VERSION;

var _require7 = require('../errors'),
    codes = _require7.codes;
/**
 * @typedef {import('libp2p-interfaces/src/connection').Connection} Connection
 * @typedef {import('libp2p-interfaces/src/stream-muxer/types').MuxedStream} MuxedStream
 */

/**
 * @typedef {Object} HostProperties
 * @property {string} agentVersion
 */


var IdentifyService = /*#__PURE__*/function () {
  /**
   * @class
   * @param {Object} options
   * @param {import('../')} options.libp2p
   */
  function IdentifyService(_ref) {
    var _this = this;

    var libp2p = _ref.libp2p;

    _classCallCheck(this, IdentifyService);

    this._libp2p = libp2p;
    this.peerStore = libp2p.peerStore;
    this.addressManager = libp2p.addressManager;
    this.connectionManager = libp2p.connectionManager;
    this.peerId = libp2p.peerId;
    this.handleMessage = this.handleMessage.bind(this);
    var protocolStr = IdentifyService.getProtocolStr(libp2p);
    this.identifyProtocolStr = protocolStr.identifyProtocolStr;
    this.identifyPushProtocolStr = protocolStr.identifyPushProtocolStr; // Store self host metadata

    this._host = _objectSpread({
      protocolVersion: "".concat(libp2p._config.protocolPrefix, "/").concat(IDENTIFY_PROTOCOL_VERSION)
    }, libp2p._options.host);
    this.peerStore.metadataBook.set(this.peerId, 'AgentVersion', uint8ArrayFromString(this._host.agentVersion));
    this.peerStore.metadataBook.set(this.peerId, 'ProtocolVersion', uint8ArrayFromString(this._host.protocolVersion)); // When a new connection happens, trigger identify

    this.connectionManager.on('peer:connect', function (connection) {
      _this.identify(connection).catch(log.error);
    }); // When self multiaddrs change, trigger identify-push

    this.peerStore.on('change:multiaddrs', function (_ref2) {
      var peerId = _ref2.peerId;

      if (peerId.toString() === _this.peerId.toString()) {
        _this.pushToPeerStore();
      }
    }); // When self protocols change, trigger identify-push

    this.peerStore.on('change:protocols', function (_ref3) {
      var peerId = _ref3.peerId;

      if (peerId.toString() === _this.peerId.toString()) {
        _this.pushToPeerStore();
      }
    });
  }
  /**
   * Send an Identify Push update to the list of connections
   *
   * @param {Connection[]} connections
   * @returns {Promise<void[]>}
   */


  _createClass(IdentifyService, [{
    key: "push",
    value: function () {
      var _push = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(connections) {
        var _this2 = this;

        var signedPeerRecord, listenAddrs, protocols, pushes;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.peerStore.addressBook.getRawEnvelope(this.peerId);

              case 2:
                signedPeerRecord = _context2.sent;
                listenAddrs = this._libp2p.multiaddrs.map(function (ma) {
                  return ma.bytes;
                });
                protocols = this.peerStore.protoBook.get(this.peerId) || [];
                pushes = connections.map( /*#__PURE__*/function () {
                  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(connection) {
                    var _yield$connection$new, stream;

                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.prev = 0;
                            _context.next = 3;
                            return connection.newStream(_this2.identifyPushProtocolStr);

                          case 3:
                            _yield$connection$new = _context.sent;
                            stream = _yield$connection$new.stream;
                            _context.next = 7;
                            return pipe([Message.Identify.encode({
                              listenAddrs: listenAddrs,
                              signedPeerRecord: signedPeerRecord,
                              protocols: protocols
                            }).finish()], lp.encode(), stream, consume);

                          case 7:
                            _context.next = 12;
                            break;

                          case 9:
                            _context.prev = 9;
                            _context.t0 = _context["catch"](0);
                            // Just log errors
                            log.error('could not push identify update to peer', _context.t0);

                          case 12:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee, null, [[0, 9]]);
                  }));

                  return function (_x2) {
                    return _ref4.apply(this, arguments);
                  };
                }());
                return _context2.abrupt("return", Promise.all(pushes));

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function push(_x) {
        return _push.apply(this, arguments);
      }

      return push;
    }()
    /**
     * Calls `push` for all peers in the `peerStore` that are connected
     *
     * @returns {void}
     */

  }, {
    key: "pushToPeerStore",
    value: function pushToPeerStore() {
      // Do not try to push if libp2p node is not running
      if (!this._libp2p.isStarted()) {
        return;
      }

      var connections = [];
      var connection;

      var _iterator = _createForOfIteratorHelper(this.peerStore.peers.values()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var peer = _step.value;

          if (peer.protocols.includes(this.identifyPushProtocolStr) && (connection = this.connectionManager.get(peer.id))) {
            connections.push(connection);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this.push(connections);
    }
    /**
     * Requests the `Identify` message from peer associated with the given `connection`.
     * If the identified peer does not match the `PeerId` associated with the connection,
     * an error will be thrown.
     *
     * @async
     * @param {Connection} connection
     * @returns {Promise<void>}
     */

  }, {
    key: "identify",
    value: function () {
      var _identify = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(connection) {
        var _yield$connection$new2, stream, _yield$pipe, _yield$pipe2, data, message, _message, publicKey, listenAddrs, protocols, observedAddr, signedPeerRecord, id, cleanObservedAddr, envelope;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return connection.newStream(this.identifyProtocolStr);

              case 2:
                _yield$connection$new2 = _context3.sent;
                stream = _yield$connection$new2.stream;
                _context3.next = 6;
                return pipe([], stream, lp.decode(), take(1), toBuffer, collect);

              case 6:
                _yield$pipe = _context3.sent;
                _yield$pipe2 = _slicedToArray(_yield$pipe, 1);
                data = _yield$pipe2[0];

                if (data) {
                  _context3.next = 11;
                  break;
                }

                throw errCode(new Error('No data could be retrieved'), codes.ERR_CONNECTION_ENDED);

              case 11:
                _context3.prev = 11;
                message = Message.Identify.decode(data);
                _context3.next = 18;
                break;

              case 15:
                _context3.prev = 15;
                _context3.t0 = _context3["catch"](11);
                throw errCode(_context3.t0, codes.ERR_INVALID_MESSAGE);

              case 18:
                _message = message, publicKey = _message.publicKey, listenAddrs = _message.listenAddrs, protocols = _message.protocols, observedAddr = _message.observedAddr, signedPeerRecord = _message.signedPeerRecord;
                _context3.next = 21;
                return PeerId.createFromPubKey(publicKey);

              case 21:
                id = _context3.sent;

                if (!(connection.remotePeer.toB58String() !== id.toB58String())) {
                  _context3.next = 24;
                  break;
                }

                throw errCode(new Error('identified peer does not match the expected peer'), codes.ERR_INVALID_PEER);

              case 24:
                // Get the observedAddr if there is one
                cleanObservedAddr = IdentifyService.getCleanMultiaddr(observedAddr);
                _context3.prev = 25;
                _context3.next = 28;
                return Envelope.openAndCertify(signedPeerRecord, PeerRecord.DOMAIN);

              case 28:
                envelope = _context3.sent;

                if (!this.peerStore.addressBook.consumePeerRecord(envelope)) {
                  _context3.next = 34;
                  break;
                }

                this.peerStore.protoBook.set(id, protocols);
                this.peerStore.metadataBook.set(id, 'AgentVersion', uint8ArrayFromString(message.agentVersion));
                this.peerStore.metadataBook.set(id, 'ProtocolVersion', uint8ArrayFromString(message.protocolVersion));
                return _context3.abrupt("return");

              case 34:
                _context3.next = 39;
                break;

              case 36:
                _context3.prev = 36;
                _context3.t1 = _context3["catch"](25);
                log('received invalid envelope, discard it and fallback to listenAddrs is available', _context3.t1);

              case 39:
                // LEGACY: Update peers data in PeerStore
                try {
                  this.peerStore.addressBook.set(id, listenAddrs.map(function (addr) {
                    return new Multiaddr(addr);
                  }));
                } catch (err) {
                  log.error('received invalid addrs', err);
                }

                this.peerStore.protoBook.set(id, protocols);
                this.peerStore.metadataBook.set(id, 'AgentVersion', uint8ArrayFromString(message.agentVersion));
                this.peerStore.metadataBook.set(id, 'ProtocolVersion', uint8ArrayFromString(message.protocolVersion)); // TODO: Add and score our observed addr

                log('received observed address of %s', cleanObservedAddr); // this.addressManager.addObservedAddr(observedAddr)

              case 44:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[11, 15], [25, 36]]);
      }));

      function identify(_x3) {
        return _identify.apply(this, arguments);
      }

      return identify;
    }()
    /**
     * A handler to register with Libp2p to process identify messages.
     *
     * @param {Object} options
     * @param {Connection} options.connection
     * @param {MuxedStream} options.stream
     * @param {string} options.protocol
     * @returns {Promise<void>|undefined}
     */

  }, {
    key: "handleMessage",
    value: function handleMessage(_ref5) {
      var connection = _ref5.connection,
          stream = _ref5.stream,
          protocol = _ref5.protocol;

      switch (protocol) {
        case this.identifyProtocolStr:
          return this._handleIdentify({
            connection: connection,
            stream: stream
          });

        case this.identifyPushProtocolStr:
          return this._handlePush({
            connection: connection,
            stream: stream
          });

        default:
          log.error('cannot handle unknown protocol %s', protocol);
      }
    }
    /**
     * Sends the `Identify` response with the Signed Peer Record
     * to the requesting peer over the given `connection`
     *
     * @private
     * @param {Object} options
     * @param {MuxedStream} options.stream
     * @param {Connection} options.connection
     * @returns {Promise<void>}
     */

  }, {
    key: "_handleIdentify",
    value: function () {
      var _handleIdentify2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref6) {
        var connection, stream, publicKey, signedPeerRecord, protocols, message;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                connection = _ref6.connection, stream = _ref6.stream;
                publicKey = new Uint8Array(0);

                if (this.peerId.pubKey) {
                  publicKey = this.peerId.pubKey.bytes;
                }

                _context4.next = 5;
                return this.peerStore.addressBook.getRawEnvelope(this.peerId);

              case 5:
                signedPeerRecord = _context4.sent;
                protocols = this.peerStore.protoBook.get(this.peerId) || [];
                message = Message.Identify.encode({
                  protocolVersion: this._host.protocolVersion,
                  agentVersion: this._host.agentVersion,
                  publicKey: publicKey,
                  listenAddrs: this._libp2p.multiaddrs.map(function (ma) {
                    return ma.bytes;
                  }),
                  signedPeerRecord: signedPeerRecord,
                  observedAddr: connection.remoteAddr.bytes,
                  protocols: protocols
                }).finish();
                _context4.prev = 8;
                _context4.next = 11;
                return pipe([message], lp.encode(), stream, consume);

              case 11:
                _context4.next = 16;
                break;

              case 13:
                _context4.prev = 13;
                _context4.t0 = _context4["catch"](8);
                log.error('could not respond to identify request', _context4.t0);

              case 16:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[8, 13]]);
      }));

      function _handleIdentify(_x4) {
        return _handleIdentify2.apply(this, arguments);
      }

      return _handleIdentify;
    }()
    /**
     * Reads the Identify Push message from the given `connection`
     *
     * @private
     * @param {object} options
     * @param {MuxedStream} options.stream
     * @param {Connection} options.connection
     * @returns {Promise<void>}
     */

  }, {
    key: "_handlePush",
    value: function () {
      var _handlePush2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref7) {
        var connection, stream, message, _yield$pipe3, _yield$pipe4, data, id, envelope;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                connection = _ref7.connection, stream = _ref7.stream;
                _context5.prev = 1;
                _context5.next = 4;
                return pipe([], stream, lp.decode(), take(1), toBuffer, collect);

              case 4:
                _yield$pipe3 = _context5.sent;
                _yield$pipe4 = _slicedToArray(_yield$pipe3, 1);
                data = _yield$pipe4[0];
                message = Message.Identify.decode(data);
                _context5.next = 13;
                break;

              case 10:
                _context5.prev = 10;
                _context5.t0 = _context5["catch"](1);
                return _context5.abrupt("return", log.error('received invalid message', _context5.t0));

              case 13:
                id = connection.remotePeer;
                _context5.prev = 14;
                _context5.next = 17;
                return Envelope.openAndCertify(message.signedPeerRecord, PeerRecord.DOMAIN);

              case 17:
                envelope = _context5.sent;

                if (!this.peerStore.addressBook.consumePeerRecord(envelope)) {
                  _context5.next = 21;
                  break;
                }

                this.peerStore.protoBook.set(id, message.protocols);
                return _context5.abrupt("return");

              case 21:
                _context5.next = 26;
                break;

              case 23:
                _context5.prev = 23;
                _context5.t1 = _context5["catch"](14);
                log('received invalid envelope, discard it and fallback to listenAddrs is available', _context5.t1);

              case 26:
                // LEGACY: Update peers data in PeerStore
                try {
                  this.peerStore.addressBook.set(id, message.listenAddrs.map(function (addr) {
                    return new Multiaddr(addr);
                  }));
                } catch (err) {
                  log.error('received invalid addrs', err);
                } // Update the protocols


                this.peerStore.protoBook.set(id, message.protocols);

              case 28:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[1, 10], [14, 23]]);
      }));

      function _handlePush(_x5) {
        return _handlePush2.apply(this, arguments);
      }

      return _handlePush;
    }()
    /**
     * Takes the `addr` and converts it to a Multiaddr if possible
     *
     * @param {Uint8Array | string} addr
     * @returns {Multiaddr|null}
     */

  }], [{
    key: "getProtocolStr",
    value:
    /**
     * @param {import('../')} libp2p
     */
    function getProtocolStr(libp2p) {
      return {
        identifyProtocolStr: "/".concat(libp2p._config.protocolPrefix, "/").concat(MULTICODEC_IDENTIFY_PROTOCOL_NAME, "/").concat(MULTICODEC_IDENTIFY_PROTOCOL_VERSION),
        identifyPushProtocolStr: "/".concat(libp2p._config.protocolPrefix, "/").concat(MULTICODEC_IDENTIFY_PUSH_PROTOCOL_NAME, "/").concat(MULTICODEC_IDENTIFY_PUSH_PROTOCOL_VERSION)
      };
    }
  }, {
    key: "getCleanMultiaddr",
    value: function getCleanMultiaddr(addr) {
      if (addr && addr.length > 0) {
        try {
          return new Multiaddr(addr);
        } catch (_) {
          return null;
        }
      }

      return null;
    }
  }]);

  return IdentifyService;
}();
/**
 * The protocols the IdentifyService supports
 *
 * @property multicodecs
 */


var multicodecs = {
  IDENTIFY: MULTICODEC_IDENTIFY,
  IDENTIFY_PUSH: MULTICODEC_IDENTIFY_PUSH
};
IdentifyService.multicodecs = multicodecs;
IdentifyService.Messsage = Message;
module.exports = IdentifyService;